import type { ComfortLocale } from "@/locales/fr/comfort";

import { EPersonalizationSeverity } from "@/types/backoffice/dto/personalization/personalization-severity-dto.ts";
import { EPersonalizationSupportType } from "@/types/backoffice/dto/personalization/personalization-support-type-dto.ts";

const comfortLocale: ComfortLocale = {
  comfort: {
    contextual: {
      cancel: "Cancel",
    },
    title: "Technical/Comfort Issues",
    history: "History",
    isTechnicalOrComfort: "Does the request concern either a technical issue or a personalization issue ?",
    technical: "Technical",
    comfort: "Comfort",
    isWholeHouse: "Does the request concern the whole accommodation ?",
    yes: "Yes",
    no: "No",
    callSeverity: "Call Severity",
    comment: "Comment",
    cta: "Submit Personalization",
    incompatibility: "Incompatibility",
    selectDevices: "Select devices",
    severities: {
      [EPersonalizationSeverity.NORMAL]: "Moderate",
      [EPersonalizationSeverity.NORMAL_LINK]: "Moderate",
      [EPersonalizationSeverity.HIGH]: "High",
      [EPersonalizationSeverity.HIGH_LINK]: "High",
      [EPersonalizationSeverity.SITE_DEACTIVATION_WITH_TERMINATION]: "Deactivation by removing access to MyVoltalis",
      [EPersonalizationSeverity.DISABLE_LINK]: "Deactivate (Links)",
      [EPersonalizationSeverity.DISABLE_SITE_FOR_21_DAYS]: "Disable for 21 days",
      [EPersonalizationSeverity.SITE_DEACTIVATION]: "Deactivation by authorizing access to MyVoltalis",
    },
    types: {
      [EPersonalizationSupportType.COMFORT]: "Comfort",
      [EPersonalizationSupportType.TECHNICAL]: "Technical",
    },
  },
};

export default comfortLocale;
